@let hasMultipleLegs = legs().length > 1;
@let isCurrentLeg = isCurrent() && (!hasSubpoints() || !subpointsExpanded());

<div
  class="leg-line"
  [class.first-subpoint]="isFirstSubpoint()"
  [class.first-leg]="isFirstLeg() && hasMultipleLegs"
  [class.last-leg]="isLastLeg() && hasMultipleLegs"
  [class.expand-top]="isFirstLeg()"
  [class.expand-bottom]="expandBottom()"
  [class.current]="isCurrentLeg"
  [class.single]="!hasMultipleLegs && !hasSubpoints()"
  [class.borders-expanded]="bordersExpanded()"
>
  @if (isCurrentLeg) {
    <ng-container *ngTemplateOutlet="completedLegLineTemplate"></ng-container>

    <ng-container *ngTemplateOutlet="rideLineTemplate"></ng-container>
  }

  <ng-container *ngTemplateOutlet="currentLegLineTemplate"></ng-container>
</div>

@let showLegData = !isPoint() || hasMultipleLegs;
@let isMiddleLeg = !isFirstLeg() && !isLastLeg();
@if (isMiddleLeg && showLegData) {
  <div class="divider"></div>
}

@let realizationCompliance =
  status() === OrderPointStatus.TO_DO && isCurrent() && compliance()
    ? compliance()
    : null;
@if (isPoint() && isFirstLeg() && !hasMultipleLegs) {
  <div class="row">
    <app-route-point-leg-summary
      [leg]="leg()"
      [routeSummary]="subpointsRouteSummary()"
      [realizationCompliance]="!hasSubpoints() ? realizationCompliance : null"
      [index]="index()"
      [subpoints]="subpoints()"
      [subpointsExpanded]="subpointsExpanded()"
      [isFirstLeg]="isFirstLeg()"
    ></app-route-point-leg-summary>
  </div>
}

@if (isFirstLeg() && subpointsExpanded()) {
  @for (
    subpoint of subpoints();
    track trackSubpoint(subpoint);
    let isFirstSubpoint = $first
  ) {
    <app-route-point
      [point]="subpoint.data"
      [isFirstSubpoint]="isFirstSubpoint"
      [style.z-index]="subpoints().length - $index"
    ></app-route-point>
  }

  @if (hasSubpoints() && legs().length === 1) {
    <div class="row">
      <div
        class="leg-line expand-top expand-bottom"
        [class.borders-expanded]="bordersExpanded()"
      >
        @if (isCurrent()) {
          <ng-container
            *ngTemplateOutlet="completedLegLineTemplate"
          ></ng-container>

          <ng-container *ngTemplateOutlet="rideLineTemplate"></ng-container>
        }

        <ng-container *ngTemplateOutlet="currentLegLineTemplate"></ng-container>
      </div>

      <app-route-point-leg-summary
        [leg]="leg()"
        [routeSummary]="routeSummary()"
        [realizationCompliance]="realizationCompliance"
        [index]="index()"
        [isFirstLeg]="isFirstLeg()"
        [(bordersExpanded)]="bordersExpanded"
      ></app-route-point-leg-summary>
    </div>
  }
}

@if (showLegData) {
  <div class="row">
    <app-route-point-leg-summary
      [leg]="leg()"
      [previousLeg]="getPreviousLeg(leg())"
      [index]="index()"
      [isFirstLeg]="isFirstLeg()"
      [(bordersExpanded)]="bordersExpanded"
    ></app-route-point-leg-summary>
  </div>

  @if (isMiddleLeg) {
    <div class="divider"></div>
  }
}

<ng-template #completedLegLineTemplate>
  <app-route-point-leg-line
    [status]="OrderPointStatus.COMPLETED"
    [compliance]="compliance()"
    [isEmpty]="isEmpty()"
    [type]="leg().type"
  ></app-route-point-leg-line>
</ng-template>

<ng-template #currentLegLineTemplate>
  <app-route-point-leg-line
    [status]="status()"
    [compliance]="compliance()"
    [isEmpty]="isEmpty()"
    [type]="leg().type"
  ></app-route-point-leg-line>
</ng-template>

<ng-template #rideLineTemplate>
  @let forceProgress = showFirstEmptyRoute() ? 0.5 : null;
  @let legProgressPercentage =
    (forceProgress ??
      telematicsItem()?.status?.offRouteData?.legProgress ??
      0.5) * 100;

  <div
    class="ride-line progress"
    [class.transit]="leg().type !== OnyxRouteLegType.VEHICLE"
    [style.grid-template-rows]="`${legProgressPercentage}% ${100 - legProgressPercentage}%`"
  >
    <ng-container *ngTemplateOutlet="completedLegLineTemplate"></ng-container>

    <app-route-point-leg-ride
      [compliance]="compliance()"
      [context]="context"
      [legProgressPercentage]="legProgressPercentage"
    ></app-route-point-leg-ride>

    <ng-container *ngTemplateOutlet="currentLegLineTemplate"></ng-container>
  </div>
</ng-template>
